export default __webpack_public_path__ + "static/media/thumbnail.a0292814.png";